import styled from 'styled-components';

import { BREAKPOINTS, colors } from 'common/styles/style-constants';

import { Div } from '../../../../../../common/styles/oc-styled-components';

export const InsuranceWarningContainer = styled(Div)`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;

  margin: 4px 0px 16px;
  padding: 8px;

  border: 1px solid ${colors.danger};
  border-radius: 8px;

  color: ${colors.danger};

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    flex-direction: column;
    text-align: center;

    && .insurance-warning-line {
      display: inline;
    }
  }
`;
